import VueI18n
    from "vue-i18n";
import {loadLocaleMessages} from "@/i18n";
import {mapState} from "vuex";
const i18nn = new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE,
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
    messages: loadLocaleMessages(),
})
const LocaleMixin = {
    i18n: i18nn,
    computed: {
        ...mapState('auth',['currencyType','distributor'])
    },
    mounted() {
        i18nn.locale = this.currencyType === 'USD' ? 'en' : 'vi'
    },
}

export default LocaleMixin;